export const LABEL_MENU = {
	HOME: {
		'home-main': 'Home',
	},
	PHARMACY: {
		'pharmacy-main': 'Farmacia',
		'pharmacy-locals': 'Sucursales',
		'pharmacy-locals-admin': 'Sucursales',
		'pharmacy-letters-admin': 'Cartas',
		'pharmacy-letters': 'Cartas',
	},
	PRODUCTS: {
		'products-main': 'Productos',
		'products-migration': 'Migración',
		'products-migration-admin': 'Migración',
		'products-stock': 'Stock y precio',
		'products-stock-admin': 'Stock y precio',
	},
	FOLLOWUP: {
		'followup-main': 'Seguimiento',
		// 'followup-notifications': 'Notificationes',
		'followup-reports-admin': 'Reportes',
		'followup-reports': 'Reportes',
		'followup-request': 'Solicitudes',
		'followup-request-admin': 'Solicitudes',
		'followup-purchase-orders': 'Ordenes de compra',
		'followup-purchase-orders-admin': 'Ordenes de compra',
		'followup-claims-admin': 'Reclamos y sugerencias',
		'followup-claims': 'Reclamos y sugerencias',
		'followup-quotation': 'Cotizaciones',
		'followup-quotation-admin': 'Cotizaciones',
		'followup-preorder': 'Pre-orden',

	},

	RECIPE_HISTORY: {
		'recipe-history-main': 'Historial de recetas',
		'recipe-history-qf-admin': 'Historial de Aprob. QF',
		'recipe-history-qf': 'Historial de Aprob. QF',
	},
	PAYMENTS: {
		'payments-main': 'Pagos',
		'payments-token': 'Token Punto Pago',
		'payments-pos': 'Reenviar POS',
	},

	CONFIGURATION: {
		'configuration-main': 'Configuración',
		'configuration-slider-admin': 'Config. de espacios publicitarios',
		'configuration-slider': 'Config. de espacios publicitarios',
		'configuration-landing-admin': 'Config. de páginas promocionales',
		'configuration-icons-admin': 'Config. de logos',
		'configuration-icons': 'Config. de logos',
		'configuration-landing': 'Config. de páginas promocionales',
		'configuration-carousel-admin': 'Config. de carrouseles',
		'configuration-carousel':'Config. de carrouseles',
		'configuration-users': 'Usuarios',
		'configuration-users-add-rol': 'Añadir rol',
		'configuration-users-local': 'Asignar local',
		'configuration-users-email': 'Email',
		'configuration-users-search': 'Buscar usuario',
		'configuration-users-management-admin': 'Gestión de usuarios',
		'configuration-users-management': 'Gestión de usuarios',
	},
};
